module.exports = __webpack_public_path__ + "media/2-15.b4b3891c.mp4";